export default {
  MuiButton: {
    variant: 'contained',
    color: 'primary',
  },
  MuiTypography: {
    color: 'primary',
  },
  MuiSwitch: {
    color: 'primary',
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/props.js